export const CHILD_OVERVIEW_STATUS = Object.freeze({
  COMMITTED: "committed",
  NO_CLASS: "no_class",
  NOT_COMMITTED: "not_committed",
  INACTIVE: "inactive",
});

export const resolveChildOverviewStatus = ({ child, hasClassroom }) => {
  if (!child || child.withdrawnAt || child.deceasedAt || child.active === false) {
    return CHILD_OVERVIEW_STATUS.INACTIVE;
  }
  if (child.committed === false) return CHILD_OVERVIEW_STATUS.NOT_COMMITTED;
  if (child.committed === true) {
    return hasClassroom ? CHILD_OVERVIEW_STATUS.COMMITTED : CHILD_OVERVIEW_STATUS.NO_CLASS;
  }
  if (hasClassroom) return CHILD_OVERVIEW_STATUS.COMMITTED;
  if (child.waiting === true) return CHILD_OVERVIEW_STATUS.NOT_COMMITTED;
  return CHILD_OVERVIEW_STATUS.INACTIVE;
};

export const hasConfiguredPrivacy = (privacyState) =>
  Boolean(
    privacyState &&
      Object.prototype.hasOwnProperty.call(privacyState, "data") &&
      privacyState.data &&
      typeof privacyState.data === "object"
  );
